import { fetchFsPlayerStatus } from "@/loyalty/api/loyalty-api";
import { FsPlayerDataStatus } from "@/loyalty/api/models/fs-player-status";
import { computed, ref } from "vue";

const maxFsPoints = 10;

const isFsPlayerDataLoaded = ref(false);
const fsPlayerDataHasError = ref(false);

const fsPlayerData = ref<FsPlayerDataStatus>({
    access: false,
    allowedToday: false,
    points: 0,
});

const hasMaxPoints = computed(() => fsPlayerData.value?.points >= maxFsPoints);

async function loadFsPlayerData() {
    try {
        fsPlayerData.value = await fetchFsPlayerStatus();
    } catch (err) {
        fsPlayerDataHasError.value = true;
        console.error(err);
    } finally {
        isFsPlayerDataLoaded.value = true;
    }
}

function updateFsPoints(newPoints: number) {
    fsPlayerData.value.points = newPoints;
}
function updateFsData(newPoints: number, access: boolean) {
    fsPlayerData.value.points = newPoints;
    fsPlayerData.value.access = access;
}

export default {
    isFsPlayerDataLoaded,
    fsPlayerData,
    hasMaxPoints,
    maxFsPoints,

    loadFsPlayerData,
    updateFsPoints,
    updateFsData,
};
